<div class="text-center">
    <img
        src="./assets/images/rocket.svg"
        alt="Publish Campaign"
        title="Publish Campaign"
        class="mb-3"
    />
    <div class="text-gray mb-4">
        You are about to launch a campaign on:<br />
        <span class="text-gray-500 montserrat-semi-bold"
            >{{ highlights.locations | number }} locations</span
        >, <br />
        <span class="text-gray-500 montserrat-semi-bold"
            >{{ highlights.screens | number }} screens</span
        >, <br />
        with a total of
        <span class="text-gray-500 montserrat-semi-bold">{{ highlights.slots | number }} slots</span
        >, <br />
        <span *ngIf="data.campaign.billingMethod == 'PER_HOUR'">
            and
            <span class="text-gray-500 montserrat-semi-bold"
                >{{ highlights.plays | number }} plays</span
            >
        </span>
        <span *ngIf="data.campaign.billingMethod == 'PER_IMPRESSION'">
            and
            <span class="text-gray-500 montserrat-semi-bold"
                >{{ highlights.totalImpressions | number }} impressions</span
            >
            <!--
                Reach is withheld when an external provider is the metrics source: its reach is
                modelled over the queried window and is not comparable to the local estimate, so
                quoting a single figure at publish time would mislead.
            -->
            <span *ngIf="!highlights.externalMetricsSource">
                , <br />
                with
                <span class="text-gray-500 montserrat-semi-bold"
                    >{{ highlights.totalReaches | number }} reach</span
                >
            </span>
        </span>

        <div *ngIf="data.hasMultipleSuppliers">
            <div>
                <br />
                <br />
                <i
                    >Your campaign includes more than one supplier, please choose how would you
                    prefer to receive your approvals.</i
                >
                <br />
                <br />
                <mat-checkbox
                    class="mr-4 montserrat-regular"
                    [(ngModel)]="isPerSupplierChecked"
                    (change)="onPerSupplierChange()"
                    >Per Supplier</mat-checkbox
                >
                <mat-checkbox
                    class="mr-4 montserrat-regular"
                    [(ngModel)]="isAllAtOnceChecked"
                    (change)="onAllAtOnceChange()"
                    >All at once</mat-checkbox
                >
            </div>

            <div>
                <br />
                <br />
                <i>Please choose how would you prefer to launch your campaign:</i>
                <br />
                <br />
                <mat-checkbox
                    class="mr-4 montserrat-regular"
                    [(ngModel)]="isGoLiveWithApprovedChecked"
                    (change)="onGoLiveWithApproveChange()"
                >
                    <p style="white-space: wrap">
                        Go live with the approved suppliers by their corresponding start date
                    </p></mat-checkbox
                >
                <mat-checkbox
                    class="mr-4 montserrat-regular"
                    [(ngModel)]="isAutomaticallyPauseCampaignChecked"
                    (change)="onAutomaticallyPauseCampaignChange()"
                >
                    <p style="white-space: wrap">
                        Automatically pause campaign until all suppliers approved
                    </p>
                </mat-checkbox>
            </div>
        </div>

        <br />
        <br />
    </div>
    <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>cancel</button>
        <button mat-dialog-close class="btn btn-md btn-gray-500" (click)="navigatePayment()">
            Checkout
        </button>
    </div>
</div>
